const labelsDE = {
    "view": {
        "table": {
            "title": "Ihre Label-Liste",
            "column": {
                "name": "Name",
                "owner": "Besitzer",
                "company": "Firma",
                "contract": "Vertrag",
                "info": "Info",
                "status": "Status",
                "action": "Aktion"
            },
            "button": {
                "edit": "Bearbeiten",
                "export_csv": "CSV exportieren"
            },
            "placeholder": {
                "search": "Suche..."
            },
            "label": {
                "approved": "Genehmigt",
                "waiting_approval": "Wartet auf Genehmigung"
            }
        },
        "message": {
            "success": "Label wurde entfernt!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!",
            "notSubscribed": "Sie haben keinen Plan abonniert, daher können Sie nur <strong>3 Labels</strong> hinzufügen. Bitte <3>abonnieren</3> Sie einen Plan, um unbegrenzte Labels nutzen zu können.",
            "subscriptionUpgrade": "Ihr aktueller Abonnementplan unterstützt diese Funktion nicht. Bitte <1>aktualisieren</1> Sie Ihren Abonnementplan, um diese Funktion zu nutzen.",
            "subscriptionExpired": "Ihr Abonnement ist abgelaufen. Bitte <1>erneuern</1> Sie Ihr Abonnement, um diese Funktion zu nutzen.",
            "noAccess": "Sie haben keinen Zugriff auf dieses Modul, bitte kontaktieren Sie das Support-Team für weitere Informationen."
        },
        "modal": {
            "delete": {
                "header": "Label {{labelName}} löschen?",
                "body": "Sind Sie sicher, dass Sie das Label {{labelName}} löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden."
            }
        }
    },
    "add": {
        "title": "Label hinzufügen",
        "form": {
            "label": {
                "required": "Erforderlich",
                "name": "Name",
                "subuser": "Unterbenutzer",
                "logo": "Logo",
                "promo_graphic": "Werbegrafik",
                "primary_genre": "Primäres Genre",
                "secondary_genre": "Sekundäres Genre",
                "year_established": "Gründungsjahr",
                "releases_in_catalog": "Veröffentlichungen im Katalog",
                "soundcloud": "Soundcloud",
                "website": "Webseite",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "youtube": "Youtube",
                "instagram": "Instagram",
                "mixcloud": "Mixcloud",
                "beatport": "Beatport"
            },
            "help_text": {
                "subuser": "Hinweis: Verwenden Sie dieses Dropdown-Menü nur, wenn Sie ein Label für einen Ihrer Unterbenutzer hinzufügen möchten, andernfalls lassen Sie es unmarkiert.",
                "logo": "Laden Sie JPG- oder PNG-Formate hoch, Auflösung nur 1000x1000 px",
                "promo_graphic": "Laden Sie JPG- oder PNG-Formate hoch, Auflösung nur 960x150px, max. 100kb"
            },
            "placeholder": {
                "subuser": "Unterbenutzer auswählen..."
            },
            "button": {
                "reset": "Zurücksetzen",
                "submit": "Einreichen"
            },
            "message": {
                "success": "Label wurde hinzugefügt!",
                "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
            }
        },
        "modal": {
            "addLabel": {
                "header": "Label {{labelName}} hinzufügen?",
                "body": "Sind Sie sicher, dass Sie ein neues Label erstellen möchten? Bitte stellen Sie sicher, dass Sie einen eindeutigen Labelnamen eingeben. Um sicher zu sein, überprüfen Sie bitte, ob der Name bereits in Geschäften wie Beatport und Traxsource existiert. Jede Einreichung muss vom Music Link-Team genehmigt und registriert werden. Wir genehmigen und registrieren neue Labels in der Regel innerhalb von 48 Stunden.",
                "button": {
                    "confirm": "Bestätigen",
                    "cancel": "Abbrechen"
                }
            }
        },
        "message": {
            "success": "Label wurde hinzugefügt!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
        }
    },
    "update": {
        "title": "Label bearbeiten",
        "form": {
            "label": {
                "required": "Erforderlich",
                "name": "Name",
                "logo": "Logo",
                "promo_graphic": "Werbegrafik",
                "primary_genre": "Primäres Genre",
                "secondary_genre": "Sekundäres Genre",
                "year_established": "Gründungsjahr",
                "releases_in_catalog": "Veröffentlichungen im Katalog",
                "soundcloud": "Soundcloud",
                "website": "Webseite",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "youtube": "Youtube",
                "instagram": "Instagram",
                "mixcloud": "Mixcloud",
                "beatport": "Beatport"
            },
            "help_text": {
                "logo": "Laden Sie JPG- oder PNG-Formate hoch, Auflösung nur 1000x1000 px",
                "promo_graphic": "Laden Sie JPG- oder PNG-Formate hoch, Auflösung nur 960x150px, max. 100kb"
            },
            "placeholder": {},
            "button": {
                "submit": "Einreichen"
            },
            "message": {
                "success": "Label wurde aktualisiert!",
                "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
            }
        }
    }
};

export default labelsDE;